define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var DurationInputViewController = require('web-agent-viewControllers/DurationInputViewController');


    var FilterItemDuration = BaseFilterItem.extend({
        ControllerName: 'FilterItemDurationViewController',
        LPTemplatesFiles: {
            filterItemDuration: "LP_filter_item_duration.html"
        },
        LPViewMap: {
            durationInput: ".lpview_duration_input"
        },

        initialize: function (constructorData) {
            this.defaultFilter = constructorData.defaultFilter;
            this.filterResetData = lpUtils.cloneObject(this.defaultFilter);
            this.titleText = constructorData.title;
            this.longerThanRange = constructorData.longerThanRange;
            this.shorterThanRange = constructorData.shorterThanRange;
            this.availableDurationUnits = constructorData.availableDurationUnits;
            this.minimumWidth = constructorData.minimumWidth || 170;

            this.filterName = constructorData.filterName;
            this.filterUIData = lpUtils.cloneObject(this.defaultFilter);
            this.filterData = lpUtils.cloneObject(this.defaultFilter);
            this.initializeView();
        },

        events: function () {
        },

        render: function () {

        }
    });



    /**
     * for filtering in open connections and web history tables
     */
    FilterItemDuration.prototype.getValue = function () {
        this.filterUIData = this.durationFilter.getValue();
        this.filterData = lpUtils.cloneObject(this.filterUIData);
        return this.filterData;
    };


    FilterItemDuration.prototype.initializeView = function () {
        var filterTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.filterItemDuration);

        this.createView({ template: filterTemplate });

        this.durationFilter = new DurationInputViewController({
            availableDurationUnits: this.availableDurationUnits,
            longerThanRange: this.longerThanRange,
            shorterThanRange: this.shorterThanRange,
            defaultFilter: this.defaultFilter,
            isSingleDurationMode: this.isSingleDurationMode,
            minimumWidth: this.minimumWidth,
            disableResize: true
        });
        this.addViewController({ viewController: this.durationFilter, target: this.LPViewMap.durationInput });

    };


    // set the display elements to the data in the filter
    FilterItemDuration.prototype.updateFilterUI = function (filterUIData) {
        this.durationFilter.setValue(filterUIData);
    };

    return FilterItemDuration;

});
